<template>
  <div v-if="initialized">
    <router-view/>
  </div>
  <div v-else v-loading.fullscreen="true"></div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      notifications: 'notifications/items',
      token: 'auth/token',
      initialized: 'auth/initialized',
    }),
  },
  methods: mapMutations({
    setInitialized: 'auth/setInitialized',
    clearNotifications: 'notifications/clear',
  }),
  created() {
    this.setInitialized();
    // if (!this.token) this.setInitialized();
  },
  watch: {
    notifications: {
      handler(notifications) {
        if (notifications.length) {
          notifications.forEach((notify) => {
            this.$notify(notify);
          });
          this.clearNotifications();
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
